import { $remark } from '@milkdown/kit/utils';
import { remarkGroupedCards as sharedRemarkGroupedCards } from '@platform/markdown';

/**
 * Milkdown wrapper for the shared remarkGroupedCards plugin.
 *
 * This wraps our shared remark plugin (used by SlackishMarkdown for view mode)
 * so it can be used in the Milkdown editor context. This ensures perfect parity
 * between view and edit modes.
 *
 * The shared plugin handles:
 * - Inline HTML format: <div class="grouped-cards">\n> Card 1\n> Card 2\n</div>
 * - Split HTML format: Opening/closing tags as separate nodes with blockquotes between
 * - Edge cases: Unbalanced tags, nested divs, empty wrappers
 *
 * @see web/src/markdown/remarkGroupedCards.ts for the core implementation
 */
export const groupedCardsRemark = $remark('grouped_cards_remark', () => {
  console.log('[groupedCardsRemark] factory registered (using shared plugin)');

  // The shared plugin is an attacher (returns a transformer)
  // Milkdown expects: factory → attacher → transformer
  // So we need to return the attacher directly
  return sharedRemarkGroupedCards;
});
